import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "signal-2",
  "use": "signal-2-usage",
  "viewBox": "0 0 640 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-signal-2 fa-w-20\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\" id=\"signal-2\"><path fill=\"currentColor\" d=\"M208 288h-32c-4.42 0-8 3.58-8 8v208c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V296c0-4.42-3.58-8-8-8zM80 384H48c-4.42 0-8 3.58-8 8v112c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V392c0-4.42-3.58-8-8-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol